import { Component, OnInit } from '@angular/core';
import { MatTabChangeEvent } from '@angular/material/tabs';
import { Router } from '@angular/router';
import { Config } from 'src/app/app-constant';
import { EncryptionService } from 'src/app/service/encryption/encryption.service';
import { HttpService } from 'src/app/service/http/http.service';
import { formatText } from 'src/app/shared/commen-function-file';
import { SharedService } from 'src/app/service/shared/shared.service';
import { calculateFiscalYear, formatYearRanges} from 'src/app/shared/commen-function-file';


@Component({
  selector: 'app-nine-box-log',
  templateUrl: './nine-box-log.component.html',
  styleUrls: ['./nine-box-log.component.scss'],
})
export class NineBoxLogComponent  implements OnInit {

  buttonColorName:any
  updateLogsData:any=[];
  deleteLogsData:any=[];
  selectedTypeTabIndex: any;
  selectedTypeTabName: any = 'Deleted Reimbursement';
  EmployeeSummaryData: any;
  loggedInUserCompanyID: any;
  loggedInUserId: any;
  loggedInCompanyFiscalyear: any | null;
  pmsYears: any = []
  selectedYearForCompetency: any ;
  fromYear: any;
  toYear: any;
  selectedYear: any;

  constructor(public sharedService: SharedService,public router: Router, private httpService: HttpService, private config: Config, private encryptionService: EncryptionService) { }

  ngOnInit() {

    this.loggedInUserCompanyID = Number(this.encryptionService.decryptData(sessionStorage.getItem('loggedInUserCompanyID')));
    this.loggedInUserId = sessionStorage.getItem('loggedInUserId');
    
    this.getpmsyearlist();
    this.getEmployee();
   

    this.loggedInCompanyFiscalyear = sessionStorage.getItem('loggedInCompanyFiscalyear');

    if (this.loggedInCompanyFiscalyear) {
      this.loggedInCompanyFiscalyear = this.encryptionService.decryptData(this.loggedInCompanyFiscalyear);
    }

  }
  formatedataVariable = formatText;
  previousPage(){
    this.router.navigate(['/home/hrportal/expense']);
  }
  onClickVariablePaySetup(event:any){}
  nextPage(){

  }
  onClickBreadcrumExpence() {
    this.router.navigate(['/home/hrportal/nineBox']);

  }

  tableDataDetails: any = [];
  onSortAssending(sortKey: any): void {
    this.tableDataDetails.sort((a: { [x: string]: number; }, b: { [x: string]: number; }) => {
      if (a[sortKey] < b[sortKey]) return -1;
      if (a[sortKey] > b[sortKey]) return 1;
      return 0;
    });
  }
  onSortDesending(sortKey: any): void {
    this.tableDataDetails.sort((a: { [x: string]: number; }, b: { [x: string]: number; }) => {
      if (a[sortKey] > b[sortKey]) return -1;
      if (a[sortKey] < b[sortKey]) return 1;
      return 0;
    });
  }

  tabTypeChanged(event: MatTabChangeEvent) {
    this.selectedTypeTabName = event.tab.textLabel;
    this.selectedTypeTabIndex = event?.index;

     this.selectedYearForCompetency = this.apiYear;

    if (this.selectedTypeTabName == 'Updated Reimbursement') {

      this. nineBoxLogsDetails();
    } else {
      this.viewDeleteLogsDetails();
    }

  }
  
   

  taskColumnHeaderInfo = [
    { label: 'Field', isMandatory: false, sortingName: 'fieldName' },
    { label: 'Old Value', isMandatory: false, sortingName: 'oldValue' },
    { label: 'New Value', isMandatory: false, sortingName: 'newValue' },
    { label: 'Changed By', isMandatory: false, sortingName: 'createdAt' },
    { label: 'Changed On', isMandatory: false, sortingName: 'updatedAt' }
  ];


  taskDeletedHeaderInfo = [
    { label: 'Band', isMandatory: true, sortingName: 'band' },
    { label: 'Questions', isMandatory: true, sortingName: 'questions' },
    { label: 'Weightage', isMandatory: true, sortingName: 'weightage' },
    { label: 'deletedUserName', isMandatory: true, sortingName: 'deleteduserName' },
    { label: 'Changed On', isMandatory: true, sortingName: 'changedOn' }
    
  ];


apiYear:any;
//   getpmsyearlist() {
//     this.httpService.callGetService(this.config.getpmsyearlist + this.loggedInUserCompanyID).subscribe((data: any) => {
//       this.pmsYears = [];

//       data?.data?.yearRanges?.forEach((ele: any) => {
//         var test = ele.split('_');
//         let obj = {
//           year: test[0] + '-' + test[1]
//         };

//         // Get current year
//         const currentYear = new Date().getFullYear();

//         // Ensure only past and current years are included
//         var yearParts = obj.year.split('-');
//         let fromYear = parseInt(yearParts[0]);
//         let toYear = parseInt(yearParts[1]);

//         // Add to pmsYears only if it's not a future year
//         if (toYear <= currentYear) {
//           this.pmsYears.push(obj);
//         }
//       });

//       this.pmsYears?.forEach((ele: any) => {
//         const currentYear = new Date().getFullYear();
//               let yearValue = '';
//       if (this.loggedInCompanyFiscalyear === 'Jan_Dec') {
//         yearValue = `${currentYear}-${currentYear}`; // Calendar year
//       } else if (this.loggedInCompanyFiscalyear === 'Apr_Mar') {
//         if (new Date().getMonth() < 3) {
//           // If it's Jan, Feb, or Mar, we're in the previous fiscal year
//           yearValue = `${currentYear - 1}-${currentYear}`;
//         } else {
//           // From Apr onwards, it's the current fiscal year
//           yearValue = `${currentYear}-${currentYear + 1}`;
//         }
// }

//         if (ele?.year == yearValue) {
//           this.selectedYearForCompetency = ele?.year;
//           this.apiYear = ele.year;

//           var test = ele?.year?.split('-');
//           this.fromYear = test[0];
//           this.toYear = test[1];
          
//           this.nineBoxLogsDetails()
//         }
//       });
    
//     });
   
 
   
//   }



  getpmsyearlist() {
    this.httpService.callGetService(this.config.getpmsyearlist + this.loggedInUserCompanyID).subscribe((data: any) => {
      this.pmsYears = formatYearRanges(data?.data?.yearRanges);

      const { fiscalStartYear, fiscalEndYear } = calculateFiscalYear(this.loggedInCompanyFiscalyear);

      const yearValue = `${fiscalStartYear}-${fiscalEndYear}`;
  
      this.setSelectedYear(yearValue);
    
    });
  }

  setSelectedYear(yearValue: string): void {
    const selectedYearObj = this.pmsYears.find((ele:any) => ele.year === yearValue);
    if (selectedYearObj) {
      this.selectedYear = this.selectedYearForCompetency = selectedYearObj.year;
      
      var test = this.selectedYearForCompetency?.split('-');
      this.fromYear = test[0];
      this.toYear = test[1];
      this.defaultCallFunctionsList();
      [this.fromYear, this.toYear] = selectedYearObj.year.split('-');
    }
  }



  defaultCallFunctionsList() {
      
      
    this.nineBoxLogsDetails()
    
     
  }





  //viewReimbursementByYear
  viewReimbursementByYear(year: any) {
    
    if (this.selectedTypeTabName == 'Updated Reimbursement'){
   
      this. nineBoxLogsDetails();
    }else{
      this.viewDeleteLogsDetails();
    }
  }

  getEmployee() {

    const request = {
      "companyId": this.loggedInUserCompanyID,
      "userId": this.loggedInUserId
    };
    this.httpService.callPostService(this.config.getTeamOfManager, request).subscribe((data: any) => {
      this.EmployeeSummaryData = data.data;
      // this. nineBoxLogsDetails();
    this.viewDeleteLogsDetails();
    })
  }
 
  nineBoxLogsDetails() {
    this.httpService.callGetService(`${this.config.viewLogsNineBoxUpdate}/${this.selectedYearForCompetency}/${this.loggedInUserCompanyID}`)
      .subscribe((result: any) => {
        console.log("API Response:", result); // Log full response for debugging
  
        if (result && result.data && Array.isArray(result.data.logs)) {
          this.updateLogsData = result.data.logs; // Assign only logs array
        } else {
          this.updateLogsData = []; // Assign empty array if logs are not found
        }
  
        console.log("Updated Logs Data:", this.updateLogsData); // Verify the extracted logs
      }, error => {
        console.error("Error fetching logs:", error);
        this.updateLogsData = []; // Handle errors gracefully
      });
  }
  
  




  


  //Delete Log
  viewDeleteLogsDetails() {
    this.httpService.callGetService(`${this.config.getviewLogsNineBoxDelete}/${this.loggedInCompanyFiscalyear}/${this.selectedYearForCompetency}/${this.loggedInUserCompanyID}`)
      .subscribe((result: any) => {
        this.deleteLogsData = result.data.content; // Ensure you get the array
        console.log(this.deleteLogsData);
      });
  }
  


  downloadUpdatedNineBoxLog() {
    const header = [
      "Field", 
      "Old Value", 
      "New Value", 
      "Changed By", 
      "Changed On", 
    
    ];
    const csvRows = [header]; 
  
    this.updateLogsData.forEach((log: any) => {
      csvRows.push([
        log.columnName,    
        log.oldValue,       
        log.newValue,        
        `${log.firstName} ${log.lastName}`,
        log.createdAt      
      ]);
    });
    let csvContent = "data:text/csv;charset=utf-8," + csvRows.map(row => row.join(",")).join("\n");
  
    const encodedUri = encodeURI(csvContent);
    const link = document.createElement("a");
    link.setAttribute("href", encodedUri);
    link.setAttribute("download", "updateNineBoxLogs.csv");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }
  

  

  downloadDeletedNineBoxLog() {
    const header = [
      "Band", 
      "Questions", 
      "Weightage", 
      "deletedUserName", 
      "Changed On", 
    
    ];
    const csvRows = [header]; 
  
    this.deleteLogsData.forEach((log: any) => {
      csvRows.push([
        log.band,          
        log.question,      
        log.weightage,     
        log.userName,    
        log.updatedAt   
      ]);
    });
  
    let csvContent = "data:text/csv;charset=utf-8," + csvRows.map(row => row.join(",")).join("\n");
  
    const encodedUri = encodeURI(csvContent);
    const link = document.createElement("a");
    link.setAttribute("href", encodedUri);
    link.setAttribute("download", "deletedNineBoxLogs.csv");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }
  

}
